<template>
  <section>
    <div class="publications">
      <TotalPublications />

      <PublicationsByMediaType v-if="showPublicationsByMediaType" />
    </div>

    <div
      v-if="isNotAllChannels"
      class="publications__by-channel"
    >
      <PublicationsOverTimeWithDistribution
        v-if="showPublicationsOverTimeWithDistribution"
      />

      <TopPublicationByChannel />
    </div>
  </section>
</template>

<script>
import { TotalPublications } from '@/components/content/TotalPublications';
import { PublicationsByMediaType } from '@/components/content/PublicationsByMediaType';
import { PublicationsOverTimeWithDistribution } from '@/components/content/PublicationsOverTimeWithDistribution';
import { TopPublicationByChannel } from '@/components/content/tables/TopPublicationByChannel';
import { isRunningProductionEnvironment } from '@/utils';

export default {
  name: 'SectionPublications',
  components: {
    TotalPublications,
    PublicationsByMediaType,
    PublicationsOverTimeWithDistribution,
    TopPublicationByChannel,
  },
  computed: {
    showPublicationsByMediaType() {
      const isYoutubeChannel = this.$store.state.ui.channel === 'YouTube';
      const isAllChannel = this.$store.state.ui.channel === 'Todas';

      return !(isYoutubeChannel || isAllChannel);
    },
    showPublicationsOverTimeWithDistribution() {
      return !isRunningProductionEnvironment;
    },
    isNotAllChannels() {
      return this.$store.state.ui.channel !== 'Todas';
    },
  },
};
</script>

<style lang="scss" scoped>
.publications {
  display: flex;

  &__by-channel {
    display: grid;
    row-gap: var(--ds-spacing-stack-md);
    margin-top: var(--ds-spacing-stack-md);
  }

  .ds-chart-box {
    width: 100%;

    &:nth-child(2n) {
      margin-left: 14px;
    }
  }
}
</style>
